import React, { useState } from "react";
import { createTitle } from "../../../redux/ducks/title";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import DisplayError from "../../dumb/DisplayError";
import useStatusThunk from "../../../hook/useStatusThunk";
import TextInput from "../../dumb/TextInput";

const CreateTitle = props => {
    const [show, hide, renderModal] = useModal();
    const [d_createTitle, status, error, event] = useStatusThunk(createTitle);

    const [name, setName] = useState();

    event.onSuccess = () => {
        setName("");
        hide(null);
    };

    return (
        <React.Fragment>
            <button className={"button button--primary " + props.className} onClick={show}>Create Title</button>

            {renderModal(
                <React.Fragment>
                    <div className="group">
                        <div className="label">Title name</div>
                        <TextInput set={setName} v={name} />
                    </div>

                    <div className="group">
                        <DisplayError error={error} />
                    </div>

                    <LoadingButton loading={status == "pending"} className="button--primary" onClick={() => { d_createTitle({ name }) }}>Create Title</LoadingButton>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default CreateTitle;